export function getFileContentType(filename: string) {
  const fileStrings = filename.split('.');
  if (fileStrings.length > 1) {
    const extension = fileStrings[fileStrings.length - 1].toLowerCase();
    switch (extension) {
      case 'tif':
      case 'tiff':
        return 'image/tiff';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'bmp':
        return 'image/bmp';
      case 'gif':
        return 'image/gif';
      case 'png':
        return 'image/png';
      case 'pdf':
        return 'application/pdf';
    }
  }

  return 'application/octet-stream';
}
